// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"102":"700dce39","922":"502bf510"}[chunkId] + ".chunk.css";
};